import React from "react";
import "./style.css";

export const CourseLandingSponsors = ({show, text, image}) => {
  
  if ( show )
    return (
      <div className="course_landing_sponsors">
          <div className="course_landing_sponsors_text">{text}</div>
          <img className="course_landing_sponsors_image d-block mx-auto" loading="lazy" src={image} alt={text} />
      </div>
    );
  
  return (<></>)
};
